export const PRICE_TYPE_LOCATION_POPUP = 'popup';
export const PRICE_TYPE_LOCATION_TOGGLER = 'toggler';
